import { createFileRoute } from "@tanstack/react-router";

import { DemoList } from "@/founder/demo/DemoList";

export const Route = createFileRoute("/founder/demo/")({
    component: RouteComponent,
});

function RouteComponent() {
    return <DemoList />;
}
